import React, { useEffect, useState } from 'react';
import styles from './ComboEffect.module.css';

interface ComboEffectProps {
  combo: number;
  visible: boolean;
  onDone?: () => void;
}

const COMBO_MESSAGES: Record<number, string> = {
  3: '三连击！🔥',
  4: '四连击！💥',
  5: '五连击！⚡',
};

const ComboEffect: React.FC<ComboEffectProps> = ({ combo, visible, onDone }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (visible && combo >= 3) {
      setShow(true);
      const t = setTimeout(() => {
        setShow(false);
        onDone?.();
      }, 1600);
      return () => clearTimeout(t);
    }
    return () => {};
  }, [visible, combo, onDone]);

  if (!show || combo < 3) return null;

  const message = COMBO_MESSAGES[combo] || `${combo}连击！🔥`;

  return (
    <div className={styles.overlay}>
      <div className={styles.comboText} key={combo}>
        <span className={styles.comboLabel}>{message}</span>
        <span className={styles.comboSub}>回答全对</span>
      </div>
    </div>
  );
};

export default ComboEffect;
